import { ActionType } from '../infrastructure/actionTypes';

export default (list = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_STATES_LIST_DONE:
      return [...action.statesList];
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/statesList.ts